import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import RoomRatesViewModeButton from 'components/RoomRatesViewModeButton';
import RoomRatesEditorSettingsMenu from 'components/RoomRatesEditorSettingsMenu';

import { RoomRatesToolbar_package$key } from '__generated__/RoomRatesToolbar_package.graphql';
import { RoomRatesToolbar_data$key } from '__generated__/RoomRatesToolbar_data.graphql';

type Props = {
  package: RoomRatesToolbar_package$key;
  data: RoomRatesToolbar_data$key;
};

const RoomRatesToolbar: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment RoomRatesToolbar_package on Package {
        ...RoomRatesEditorSettingsMenu_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment RoomRatesToolbar_data on Query {
        ...RoomRatesEditorSettingsMenu_data
      }
    `,
    props.data
  );

  return (
    <Stack
      direction="row"
      spacing={2}
      divider={<Divider orientation="vertical" flexItem />}>
      <Box>
        <RoomRatesViewModeButton mode="accommodation" sx={{ mr: 1 }}>
          Nakvynės kaina
        </RoomRatesViewModeButton>
      </Box>

      <Box sx={{ display: 'flex' }}>
        <RoomRatesEditorSettingsMenu package={pack} data={data} />

        <Divider flexItem orientation="vertical" sx={{ pl: 2, mr: 2 }} />
      </Box>
    </Stack>
  );
};

export default RoomRatesToolbar;
